import { render, staticRenderFns } from "./SelectCtrPlc.vue?vue&type=template&id=061fcc4e"
import script from "./SelectCtrPlc.vue?vue&type=script&lang=js"
export * from "./SelectCtrPlc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('061fcc4e')) {
      api.createRecord('061fcc4e', component.options)
    } else {
      api.reload('061fcc4e', component.options)
    }
    module.hot.accept("./SelectCtrPlc.vue?vue&type=template&id=061fcc4e", function () {
      api.rerender('061fcc4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trans/SelectCtrPlc.vue"
export default component.exports